export { default } from "./Badge";
export type { BadgeProps, BadgeSize, BadgeTone, BadgeVariant } from "./Badge";
